
import { Component, Prop, Vue } from 'vue-property-decorator'
import { List } from '@mg/micro/vue2/List'
import { GET_MENU_ITEM_FULL } from '~/graphql/gql/menu'
import { getMenuVariables } from '~/utils/getMenuVariables'
import { GQLMenu } from '~/graphql/__generated__/interfaces'

@Component<HeaderHorizonMenu>({
  apollo: {
    getHorizonMenu: {
      fetchPolicy: 'cache-only',
      query: GET_MENU_ITEM_FULL,
      update(data: { getMenu: GQLMenu }) {
        return data.getMenu
      },
      variables() {
        return getMenuVariables(
          'horizon',
          this.$route.query.naviPreview as string,
          this.$shopConfig.abTests.abTestsData.menuAbTest,
          false
        )
      },
    },
  },
  components: {
    List,
  },
})
export default class HeaderHorizonMenu extends Vue {
  @Prop(String) cacheKey: string
  getHorizonMenu: GQLMenu

  get horizonMenuItems() {
    return (this.getHorizonMenu?.data ?? []).map((item) => ({
      href: item.url,
      imageId: item.image?.imageId ?? '',
      format: 'document',
      imageWidth: 18,
      imageHeight: 18,
      text: item.name,
    }))
  }
}
